import { User } from '../user';
import { AdImage, exampleAdImage } from './AdImage';
import { AdVideo, exampleAdVideo } from './AdVideo';
import { exampleLeadCard, LeadCard } from './LeadCard';
import { AdCreativeReview } from './AdCreativeAssetApproval';
import { FacebookAdError } from '.';

export enum AdCreativeStatus {
  ACTIVE = 'ACTIVE',
  IN_PROCESS = 'IN_PROCESS',
  WITH_ISSUES = 'WITH_ISSUES',
  DELETED = 'DELETED',
}

export enum AssetApprovalStatus {
  Draft = 'draft',
  Pending = 'pending',
  Rejected = 'rejected',
  Approved = 'approved',
  Ready = 'ready',
  Published = 'published',
}

export enum CreativeOrigin {
  Facebook = 0,
  MarketingMilk = 1,
  BulkImport = 2,
}

export enum FBCallToAction {
  ADD_TO_CART = 'ADD_TO_CART',
  APPLY_NOW = 'APPLY_NOW',
  BOOK_NOW = 'BOOK_NOW',
  BOOK_TRAVEL = 'BOOK_TRAVEL',
  BUY = 'BUY',
  BUY_NOW = 'BUY_NOW',
  BUY_TICKETS = 'BUY_TICKETS',
  CALL = 'CALL',
  CALL_ME = 'CALL_ME',
  CONTACT = 'CONTACT',
  CONTACT_US = 'CONTACT_US',
  DONATE = 'DONATE',
  DONATE_NOW = 'DONATE_NOW',
  DOWNLOAD = 'DOWNLOAD',
  EVENT_RSVP = 'EVENT_RSVP',
  FIND_A_GROUP = 'FIND_A_GROUP',
  FIND_YOUR_GROUPS = 'FIND_YOUR_GROUPS',
  FOLLOW_NEWS_STORYLINE = 'FOLLOW_NEWS_STORYLINE',
  FOLLOW_PAGE = 'FOLLOW_PAGE',
  FOLLOW_USER = 'FOLLOW_USER',
  GET_DIRECTIONS = 'GET_DIRECTIONS',
  GET_OFFER = 'GET_OFFER',
  GET_OFFER_VIEW = 'GET_OFFER_VIEW',
  GET_SHOWTIMES = 'GET_SHOWTIMES',
  GET_QUOTE = 'GET_QUOTE',
  INSTALL_APP = 'INSTALL_APP',
  INSTALL_MOBILE_APP = 'INSTALL_MOBILE_APP',
  LEARN_MORE = 'LEARN_MORE',
  LIKE_PAGE = 'LIKE_PAGE',
  LISTEN_MUSIC = 'LISTEN_MUSIC',
  LISTEN_NOW = 'LISTEN_NOW',
  MESSAGE_PAGE = 'MESSAGE_PAGE',
  MOBILE_DOWNLOAD = 'MOBILE_DOWNLOAD',
  MOMENTS = 'MOMENTS',
  NO_BUTTON = 'NO_BUTTON',
  OPEN_LINK = 'OPEN_LINK',
  ORDER_NOW = 'ORDER_NOW',
  PAY_TO_ACCESS = 'PAY_TO_ACCESS',
  PLAY_GAME = 'PLAY_GAME',
  PURCHASE_GIFT_CARDS = 'PURCHASE_GIFT_CARDS',
  RECORD_NOW = 'RECORD_NOW',
  REFER_FRIENDS = 'REFER_FRIENDS',
  REQUEST_TIME = 'REQUEST_TIME',
  SAY_THANKS = 'SAY_THANKS',
  SEE_MORE = 'SEE_MORE',
  SELL_NOW = 'SELL_NOW',
  SEND_A_GIFT = 'SEND_A_GIFT',
  SHARE = 'SHARE',
  SHOP_NOW = 'SHOP_NOW',
  SIGN_UP = 'SIGN_UP',
  SOTTO_SUBSCRIBE = 'SOTTO_SUBSCRIBE',
  START_ORDER = 'START_ORDER',
  SWIPE_UP_PRODUCT = 'SWIPE_UP_PRODUCT',
  SWIPE_UP_SHOP = 'SWIPE_UP_SHOP',
  SUBSCRIBE = 'SUBSCRIBE',
  UPDATE_APP = 'UPDATE_APP',
  USE_APP = 'USE_APP',
  USE_MOBILE_APP = 'USE_MOBILE_APP',
  VIDEO_ANNOTATION = 'VIDEO_ANNOTATION',
  VISIT_PAGES_FEED = 'VISIT_PAGES_FEED',
  WATCH_MORE = 'WATCH_MORE',
  WATCH_VIDEO = 'WATCH_VIDEO',
  WHATSAPP_MESSAGE = 'WHATSAPP_MESSAGE',
  WOODHENGE_SUPPORT = 'WOODHENGE_SUPPORT',
}

export enum FBAdPreviewFormat {
  AUDIENCE_NETWORK_INSTREAM_VIDEO = 'AUDIENCE_NETWORK_INSTREAM_VIDEO',
  AUDIENCE_NETWORK_INSTREAM_VIDEO_MOBILE = 'AUDIENCE_NETWORK_INSTREAM_VIDEO_MOBILE',
  AUDIENCE_NETWORK_OUTSTREAM_VIDEO = 'AUDIENCE_NETWORK_OUTSTREAM_VIDEO',
  AUDIENCE_NETWORK_REWARDED_VIDEO = 'AUDIENCE_NETWORK_REWARDED_VIDEO',
  DESKTOP_FEED_STANDARD = 'DESKTOP_FEED_STANDARD',
  FACEBOOK_STORY_MOBILE = 'FACEBOOK_STORY_MOBILE',
  INSTAGRAM_EXPLORE_CONTEXTUAL = 'INSTAGRAM_EXPLORE_CONTEXTUAL',
  INSTAGRAM_EXPLORE_IMMERSIVE = 'INSTAGRAM_EXPLORE_IMMERSIVE',
  INSTAGRAM_STANDARD = 'INSTAGRAM_STANDARD',
  INSTAGRAM_STORY = 'INSTAGRAM_STORY',
  INSTANT_ARTICLE_RECIRCULATION_AD = 'INSTANT_ARTICLE_RECIRCULATION_AD',
  INSTANT_ARTICLE_STANDARD = 'INSTANT_ARTICLE_STANDARD',
  INSTREAM_VIDEO_DESKTOP = 'INSTREAM_VIDEO_DESKTOP',
  INSTREAM_VIDEO_IMAGE = 'INSTREAM_VIDEO_IMAGE',
  INSTREAM_VIDEO_MOBILE = 'INSTREAM_VIDEO_MOBILE',
  JOB_BROWSER_DESKTOP = 'INSTREAM_VIDEO_MOBILE',
  JOB_BROWSER_MOBILE = 'JOB_BROWSER_MOBILE',
  MARKETPLACE_MOBILE = 'MARKETPLACE_MOBILE',
  MESSENGER_MOBILE_INBOX_MEDIA = 'MESSENGER_MOBILE_INBOX_MEDIA',
  MESSENGER_MOBILE_STORY_MEDIA = 'MESSENGER_MOBILE_STORY_MEDIA',
  MOBILE_BANNER = 'MOBILE_BANNER',
  MOBILE_FEED_BASIC = 'MOBILE_FEED_BASIC',
  MOBILE_FEED_STANDARD = 'MOBILE_FEED_STANDARD',
  MOBILE_FULLWIDTH = 'MOBILE_FULLWIDTH',
  MOBILE_INTERSTITIAL = 'MOBILE_INTERSTITIAL',
  MOBILE_MEDIUM_RECTANGLE = 'MOBILE_MEDIUM_RECTANGLE',
  MOBILE_NATIVE = 'MOBILE_NATIVE',
  RIGHT_COLUMN_STANDARD = 'RIGHT_COLUMN_STANDARD',
  SUGGESTED_VIDEO_DESKTOP = 'SUGGESTED_VIDEO_DESKTOP',
  SUGGESTED_VIDEO_MOBILE = 'SUGGESTED_VIDEO_MOBILE',
  WATCH_FEED_HOME = 'WATCH_FEED_HOME',
  WATCH_FEED_MOBILE = 'WATCH_FEED_MOBILE',
}

export enum AdCreativeType {
  single_image = 'single_image',
  single_video = 'single_video',
  carousel = 'carousel',
  dynamic = 'dynamic',
}

export interface AdCreativeDTO {
  url: string;
  format: AdCreativeType;
  name: string;
  callToAction?: FBCallToAction;
  graphicText?: string;
  primaryText?: string;
  headline?: string;
  description?: string;
  displayLink?: string;
  // carousel and dynamic only
  endSlide?: boolean; // default true
  dynamicOrder?: boolean; // default true
}

export type CreativeMediaType = 'image' | 'video';

export interface AdCreativeCarouselSlideDTOProps {
  id?: number; // allows to avoid unnecessary deletes
  url: string;
  mediaType: CreativeMediaType;
  order: number;
  headline?: string;
  description?: string;
}

export interface AdCreativeImageCarouselSlideDTO
  extends AdCreativeCarouselSlideDTOProps {
  mediaType: 'image';
  imageID: number;
}
export interface AdCreativeVideoCarouselSlideDTO
  extends AdCreativeCarouselSlideDTOProps {
  mediaType: 'video';
  videoID: number;
}

export type AdCreativeCarouselSlideDTO =
  | AdCreativeImageCarouselSlideDTO
  | AdCreativeVideoCarouselSlideDTO;

export interface AdCreativeDraft {
  name: string;
  format: AdCreativeType;
}

export interface ImageCreativeDTO extends AdCreativeDTO {
  format: AdCreativeType.single_image;
  imageID?: number;
}

export interface VideoCreativeDTO extends AdCreativeDTO {
  format: AdCreativeType.single_video;
  videoID?: number;
}

export interface AdCreativeCarouselDTO
  extends Omit<AdCreativeDTO, 'description' | 'headline'> {
  format: AdCreativeType.carousel;
  slides: AdCreativeCarouselSlideDTO[]; // 2 - 5
}

export interface DynamicCreativeDTO
  extends Omit<
    AdCreativeDTO,
    | 'callToAction'
    | 'primaryText'
    | 'headline'
    | 'description'
    | 'graphicText'
    | 'endSlide'
    | 'dynamicOrder'
  > {
  format: AdCreativeType.dynamic;
  imageIDs: number[];
  videoIDs: number[];
  primaryTexts?: string[];
  headlines?: string[];
  descriptions?: string[];
  callToActions?: FBCallToAction[];
}

export const exampleCreativeDTO: AdCreativeDTO = {
  format: AdCreativeType.single_image,
  url: 'foo.com',
  name: 'New Image Creative',
  graphicText: 'Graphics',
  primaryText: 'This is primarily',
  headline: 'Headline',
  description: 'This is a desc',
  displayLink: 'DisplayLink.com',
  callToAction: FBCallToAction.LEARN_MORE,
};

export const exampleImageCreativeDTO: ImageCreativeDTO = {
  ...exampleCreativeDTO,
  format: AdCreativeType.single_image,
  imageID: 1,
};

export const exampleVideoCreativeDTO: VideoCreativeDTO = {
  ...exampleCreativeDTO,
  format: AdCreativeType.single_video,
  videoID: 1,
};

export const exampleCarouselCreativeSlideDTO: AdCreativeCarouselSlideDTO = {
  url: 'url.com',
  order: 1,
  headline: 'This is a headline',
  description: 'desc here',
  imageID: 1,
  mediaType: 'image',
};

export const exampleCarouselCreativeSlidesDTO: AdCreativeCarouselSlideDTO[] = [
  exampleCarouselCreativeSlideDTO,
  { ...exampleCarouselCreativeSlideDTO, videoID: 1, mediaType: 'video' },
];

export const exampleCarouselCreativeDTO: AdCreativeCarouselDTO = {
  format: AdCreativeType.carousel,
  url: 'foo.com',
  name: 'New Image Creative',
  graphicText: 'Graphics',
  primaryText: 'This is primarily',
  displayLink: 'DisplayLink.com',
  callToAction: FBCallToAction.LEARN_MORE,
  slides: exampleCarouselCreativeSlidesDTO,
  dynamicOrder: true,
  endSlide: true,
};

export const exampleDynamicCreativeDTO: DynamicCreativeDTO = {
  url: 'foo.com',
  format: AdCreativeType.dynamic,
  name: 'New DYnamic Creative',
  imageIDs: [1],
  videoIDs: [1],
  primaryTexts: [
    'This is a body 1',
    'This is body 2',
    'I have stolen this body',
  ],
  headlines: ['This just in!', 'Breaking news!'],
  descriptions: ['want more news? be sure to subscribe'],
  callToActions: [FBCallToAction.ADD_TO_CART],
};

// Passed as a Get Param
export interface DynamicAdPreviewSpecProps {
  mediaType: CreativeMediaType;
  url?: string;
  primaryText?: string;
  headline?: string;
  description?: string;
  displayLink?: string;
  callToAction?: FBCallToAction;
}

export interface DynamicImageAdPreviewSpec extends DynamicAdPreviewSpecProps {
  mediaType: 'image';
  imageID: number;
}

export interface DynamicVideoAdPreviewSpec extends DynamicAdPreviewSpecProps {
  mediaType: 'video';
  videoID: number;
}

export type DynamicAdPreviewSpec =
  | DynamicImageAdPreviewSpec
  | DynamicVideoAdPreviewSpec;

export interface DynamicAdPreviewDTO {
  creative: DynamicAdPreviewSpec;
  format?: FBAdPreviewFormat;
}

export const exampleDynamicAdPreviewSpec: DynamicAdPreviewSpec = {
  mediaType: 'image',
  imageID: 1,
  url: 'url.com',
  primaryText: 'here is the body',
  headline: 'here is a headline',
  description: 'desc here',
  displayLink: 'example.com',
  callToAction: FBCallToAction.ADD_TO_CART,
};

export interface AdCreativeDynamicOptions {
  images: AdImage[];
  videos: AdVideo[];
  primaryTexts?: string[];
  headlines?: string[];
  descriptions?: string[];
  callToActions?: FBCallToAction[];
}

export interface AdCreative {
  id: number;
  name: string;
  format: AdCreativeType;
  status: AdCreativeStatus;
  s3Preview?: string;
  effectiveObjectStoryID?: string;
  isHidden: boolean;
  deletedAt?: number;
  deletedBy?: User;
  orderNo?: number;
  locked: boolean;
  imageURL?: string;
  destinationURL?: string;
  callToAction?: FBCallToAction;
  thumbnailURL?: string;
  graphicText?: string;
  primaryText?: string;
  linkHeadline?: string;
  linkDescription?: string;
  linkWebsiteURL?: string;
  linkDisplayURL?: string;
  // The strategist's reasoning for this ad. Never sent to Facebook; read by the
  // sprint packet's strategy grouping and rendered to the client.
  justification?: string;
  lastUsed?: number;
  createdAt?: number;
  creativeOrigin: CreativeOrigin;
  singleImage?: AdImage;
  singleVideo?: AdVideo;
  carouselSlides?: AdCreativeCarouselSlide[];
  carouselEndSlide?: boolean;
  carouselDynamicOrder?: boolean;
  dynamicConfig?: AdCreativeDynamicOptions;
  dynamicImages?: AdImage[];
  dynamicVideos?: AdVideo[];
  leadCardUsed?: LeadCard;
  reviewStatus: AssetApprovalStatus;
  reviewType: 'internal' | 'external';
  reviews: AdCreativeReview[];
  cascadingVariationID?: number;
  errors?: FacebookAdError[];
  sprintId?: number;
}

export const exampleAdCreativeDynamicOptions: AdCreativeDynamicOptions = {
  images: [exampleAdImage],
  videos: [exampleAdVideo],
  primaryTexts: [
    'This is a body 1',
    'This is body 2',
    'I have stolen this body',
  ],
  headlines: ['This just in!', 'Breaking news!'],
  descriptions: ['want more news? be sure to subscribe'],
  callToActions: [FBCallToAction.ADD_TO_CART],
};

export const exampleAdCreative: AdCreative = {
  id: 1,
  name: 'test name',
  isHidden: false,
  deletedAt: undefined,
  locked: false,
  deletedBy: undefined,
  format: AdCreativeType.single_image,
  status: AdCreativeStatus.IN_PROCESS,
  s3Preview: undefined,
  effectiveObjectStoryID: '123',
  imageURL: 'https://facebook.com/image.png',
  callToAction: FBCallToAction.APPLY_NOW,
  thumbnailURL: 'https://facebook.com/tiny_image.png',
  graphicText: 'Graphic Text for Designers',
  primaryText:
    'This is the main body of the message on the ad, the long one, but max of 180 chars according to mockup',
  linkHeadline: 'This just in!',
  linkDescription: 'seriously... just dropped in',
  linkWebsiteURL: 'fb.com',
  linkDisplayURL: 'iamaprettyurl.com',
  lastUsed: 1595533091,
  createdAt: 1595533091,
  creativeOrigin: CreativeOrigin.Facebook,
  singleImage: exampleAdImage,
  leadCardUsed: exampleLeadCard,
  reviewStatus: AssetApprovalStatus.Draft,
  reviewType: 'internal',
  reviews: [],
};

export interface AdCreativeCarouselSlideProps {
  linkWebsiteURL: string;
  mediaType?: CreativeMediaType;
  linkHeadline?: string;
  linkDescription?: string;
  id?: number;
}

export interface AdCreativeCarouselImageSlide
  extends AdCreativeCarouselSlideProps {
  mediaType: 'image';
  image: AdImage;
}

export interface AdCreativeCarouselVideoSlide
  extends AdCreativeCarouselSlideProps {
  mediaType: 'video';
  video: AdVideo;
}

export interface AdCreativeCarouselMedialessSlide
  extends AdCreativeCarouselSlideProps {
  mediaType?: undefined;
}

export type AdCreativeCarouselSlide =
  | AdCreativeCarouselImageSlide
  | AdCreativeCarouselVideoSlide
  | AdCreativeCarouselMedialessSlide;

export const exampleAdCreativeCarouselSlide: AdCreativeCarouselSlide = {
  linkWebsiteURL: 'url.com',
  linkHeadline: 'this is a headline',
  linkDescription: 'desc here',
  mediaType: 'image',
  image: exampleAdImage,
};

export interface FBAdCreativePreview {
  body: string; // iframe
}

export const exampleAdCreativePreview: FBAdCreativePreview = {
  body: '<iframe />',
};

export interface ShareAdCreativeDTO {
  businessID: number;
}
